export default __webpack_public_path__ + "static/media/store-front.2c30bd2e.gif";